/** UI texts: settings. Each key must exist in both languages. */
export const settings = {
  en: {
    "set.navLabel": "Settings sections",
    "set.nav.users": "Users",
    "set.nav.domain": "Domain",
    "set.mode.title": "Operating mode",
    "set.mode.hint": "Development: changes show at once. Production: built and fast.",
    "set.mode.dev": "Development",
    "set.mode.prod": "Production",
    "set.mode.confirm": "Switch to {mode}? The app restarts at the end (to production it is built first, 1–2 minutes); a failed build keeps the current mode.",
    "set.mode.running": "Switching to {mode} — the app restarts at the end, this page reloads by itself …",
    "set.mode.failed": "The switch to {mode} failed; the app keeps running as before.",
    "set.mode.done": "Switched to {mode} on {date}.",
    "set.domain.hint": "The address this installation answers under. At your domain provider point an A record (and AAAA for IPv6) of the name to this server's IP; HTTPS then comes by itself on the first visit.",
    "set.domain.host": "Domain",
    "set.domain.placeholder": "e.g. trading.example.com",
    "set.domain.apply": "Apply and check",
    "set.domain.checking": "Checking — the certificate is fetched now, this can take up to a minute …",
    "set.domain.recheck": "Check again",
    "set.domain.remove": "Remove",
    "set.domain.removeConfirm": "Remove the domain {host}? HTTPS ends for it; the app stays reachable through the server's IP.",
    "set.domain.none": "No domain yet: the app answers under the server's IP (without HTTPS).",
    "set.domain.active": "Active since {date} — https://{host}",
    "set.domain.pending": "Not checked yet",
    "set.domain.failed": "Check failed",
    "set.adminOnly": "Administrators only",
    "set.nav.layers": "Chart layers",
    "set.nav.preferences": "Preferences",
    "set.nav.data": "Market data",
    "set.nav.platform": "Platform",
    "set.messenger.row": "Telegram bot",
    "set.messenger.none": "Not set up",
    "set.messenger.posting": "{bot} → {chat}",
    "set.messenger.noChat": "{bot} · no channel chosen yet",
    "set.messenger.setUp": "Set up",
    "set.messenger.change": "Manage",
    "set.messenger.setUpTitle": "Set up Telegram",
    "set.messenger.step.bot": "1. The bot",
    "set.messenger.step.chat": "2. The channel or group",
    "set.messenger.otherBot": "Another bot",
    "set.messenger.chatNow": "Posts to {chat}",
    "set.messenger.chatStep1": "Add {bot} to your channel or group as an administrator (channel: Administrators → Add admin; group: Add members).",
    "set.messenger.chatStep2": "Then look for it here and choose it — the bot posts a short confirmation there.",
    "set.messenger.search": "Look for chats",
    "set.messenger.noChats": "No channel or group found yet. Add {bot} and look again. Still missing? Telegram tells the bot only of the last 24 hours: write /start{bot} in the group (the bot does not see plain messages there), or post something in the channel, then look again. Your own chat with the bot is not offered — only those who join a channel or group read the tips.",
    "set.messenger.kind.channel": "Channel",
    "set.messenger.kind.group": "Group",
    "set.messenger.choose": "Choose",
    "set.messenger.chosen": "Chosen",
    "set.messenger.step1": "In Telegram, open @BotFather and send /newbot.",
    "set.messenger.step2": "Choose a name and a username ending in “bot” (e.g. IllustradingBot).",
    "set.messenger.step3": "Copy the token from its reply and paste it below — the whole reply works too.",
    "set.messenger.hint": "Posts every new trade tip to a Telegram channel or group — whoever should read the tips joins it.",
    "set.messenger.token": "Bot token",
    "set.messenger.tokenHelp": "123456789:AAH… — or paste BotFather's whole reply",
    "set.messenger.save": "Test and save",
    "set.messenger.saveHint": "The token is tested with Telegram before it is stored (encrypted); a bot set up before is replaced.",
    "set.messenger.remove": "Remove bot",
    "set.messenger.removeConfirm": "Remove the bot {bot}? It no longer posts the new tips.",
    "set.section.layers.title": "Chart layers",
    "set.section.preferences.title": "Preferences",
    "set.section.preferences.description": "Language and display preferences.",
    "set.section.data.title": "Market data",
    "set.section.data.description": "Which market-data provider serves each asset class, and how often data is refreshed.",
    "set.section.platform.title": "Platform",
    "set.section.platform.description": "Administrator settings.",
    "set.saved": "Saved — applied immediately.",
    "set.confirmReset": "Restore the default {name}?",
    "set.defaultsRestored": "Defaults restored.",
    "set.saving": "Saving…",
    "set.autoSave": "Changes are saved automatically.",
    "set.saveChanges": "Save changes",
    "set.discard": "Discard",
    "set.restoreDefaults": "Restore defaults",
    "set.data.otherTitle": "News, calendar, refresh",
    "set.data.providerTitle": "Provider per asset class",
    "set.account.roleAdmin": "Administrator",
    "set.account.roleUser": "User",
    "set.users.hint": "Everyone registered on this platform. Administrators also manage the market data, the platform and the users; each user has their own watchlist and settings.",
    "set.users.name": "User",
    "set.users.vote": "Voting",
    "set.users.voteHelp": "Who may use the community vote: vote (give trade tips, vote on the others', get the notifications), view only (see the tips and votes, get the notifications), or off.",
    "set.users.voteAdmin": "Administrators always vote.",
    "set.users.voteOf": "Voting of {name}",
    "set.users.voteAccess.vote": "Vote",
    "set.users.voteAccess.view": "View only",
    "set.users.voteAccess.off": "Off",
    "set.users.role": "Role",
    "set.users.email": "E-mail",
    "set.users.since": "Registered",
    "set.users.lastSeen": "Last visited",
    "set.users.you": "you",
    "set.users.add": "Add user",
    "set.users.password": "Password (min. 10 characters)",
    "set.users.added": "{name} added — they sign in with this e-mail address and password.",
    "set.users.roleOf": "Role of {name}",
    "set.users.delete": "Delete {name}",
    "set.users.deleteConfirm": "Delete {name} ({email}) for good — with their tips, votes, watchlist, settings and drawings?",

    "field.suffix.atr": "× ATR",
    "field.suffix.minutes": "minutes",
    "field.suffix.bars": "bars",
    // chart layers — one group per layer of the layers menu
    "set.group.layers.events": "Structure (sweep / BOS)",
    "set.group.layers.levels": "Support / resistance / liquidity",
    "set.group.layers.fvg": "Fair value gaps",
    "set.group.layers.orderBlocks": "Order blocks",
    "set.group.layers.breakers": "Breaker blocks",
    "set.group.layers.poi": "POI (point of interest)",
    "set.group.layers.supplyDemand": "Supply / demand (Seiden)",
    "set.group.layers.srZones": "Support / resistance zones",
    "set.group.layers.dayLevels": "Day levels (New York)",
    "set.layers.note": "How the chart's layers are drawn: how far back and how many of the structure's events, levels, liquidity, fair value gaps, order and breaker blocks, points of interest, supply / demand and support / resistance zones and candle structures are shown, and the round numbers. Display only: the checks and the model measure the same blocks regardless.",
    "field.layers.events.bars.label": "Events shown back",
    "field.layers.events.bars.help": "Breaks of structure and sweeps within this many bars are drawn.",
    "field.layers.events.max.label": "Events at most",
    "field.layers.events.max.help": "The newest events drawn at once.",
    "field.layers.levels.lookback.label": "Swing levels look back",
    "field.layers.levels.lookback.help": "Swing highs above and lows below price within this many bars count as resistance / support.",
    "field.layers.levels.perSide.label": "Levels per side",
    "field.layers.levels.perSide.help": "How many of the latest swing highs above and swing lows below price are drawn as resistance / support.",
    "field.layers.levels.liquidityBars.label": "Liquidity looks back",
    "field.layers.levels.liquidityBars.help": "Equal highs / lows within this many bars that were never closed through form a liquidity pool.",
    "field.layers.levels.liquidityTolAtr.label": "Equal highs / lows within",
    "field.layers.levels.liquidityTolAtr.help": "Swings at most this many ATR apart count as equal (one pool).",
    "field.layers.levels.liquidityMax.label": "Liquidity pools at most",
    "field.layers.levels.liquidityMax.help": "The pools nearest to price drawn (0 = none).",
    "field.layers.fvg.lookback.label": "Open gaps shown back",
    "field.layers.fvg.lookback.help": "An open gap within this many bars is drawn.",
    "field.layers.fvg.max.label": "Gaps at most",
    "field.layers.fvg.max.help": "The newest open gaps drawn at once.",
    "field.layers.orderBlocks.max.label": "Order blocks at most",
    "field.layers.orderBlocks.max.help": "The newest order blocks still standing, drawn at once (LuxAlgo: 5).",
    "field.layers.breakers.max.label": "Breaker blocks at most",
    "field.layers.breakers.max.help": "The newest breaker blocks still standing, drawn at once.",
    "field.layers.poi.max.label": "POIs at most",
    "field.layers.poi.max.help": "The newest points of interest — open, untouched order blocks and gaps a break of structure left — drawn at once.",
    "field.layers.supplyDemand.lookback.label": "Zones shown back",
    "field.layers.supplyDemand.lookback.help": "A zone whose base lies within this many bars is drawn.",
    "field.layers.supplyDemand.max.label": "Zones at most",
    "field.layers.supplyDemand.max.help": "The newest zones still standing, drawn at once.",
    "field.layers.srZones.lookback.label": "Swings looked back",
    "field.layers.srZones.lookback.help": "The swing highs and lows within this many bars are bundled into zones.",
    "field.layers.srZones.widthAtr.label": "Zone width",
    "field.layers.srZones.widthAtr.help": "Swings this close to each other form one zone (1 ATR: a swing ± half an ATR).",
    "field.layers.srZones.max.label": "Zones at most",
    "field.layers.srZones.max.help": "The strongest zones (most swings) that do not overlap.",
    "field.layers.dayLevels.roundStep.label": "Round numbers every",
    "field.layers.dayLevels.roundStep.help": "The round price levels next to price drawn as day levels (0 = none).",
    "set.table.setting": "Setting",
    "set.table.description": "Description",
    "set.table.value": "Value",
    "set.table.default": "Default",
    "set.choice.none": "none",
    "set.table.applyDefault": "Take the default",
    "set.value.on": "On",
    "set.value.off": "Off",
    "field.preferences.language.label": "Language",
    "field.preferences.language.help": "Language of the interface.",
    "field.preferences.language.de": "Deutsch",
    "field.preferences.language.en": "English",
    "field.preferences.theme.label": "Appearance",
    "field.preferences.setupTimeframe.label": "Standard timeframe",
    "field.preferences.setupTimeframe.help": "A market opens on this timeframe (change it in the chart); the watchlist's change is measured on it.",
    "field.preferences.timeZone.label": "Time zone",
    "field.preferences.timeZone.help": "Every time of the app is shown in it: the chart's axis and crosshair, calendar, news and tips (also chosen at the clock at the chart's foot).",
    "field.preferences.theme.system": "Match system",
    "field.preferences.theme.blue": "Blue",
    "field.preferences.theme.green": "Green",
    "field.preferences.theme.red": "Red",
    "field.preferences.theme.white": "White",
    "field.data.refreshMinutesDaily.label": "Refresh daily data every",
    "field.data.refreshMinutesIntraday.label": "Refresh intraday data every",
    "field.platform.operator.label": "Provider",
    "field.platform.operator.help": "Name of the person or company that runs the platform — shown in the imprint, the terms and the privacy notice.",
    "field.platform.address.label": "Postal address",
    "field.platform.address.help": "Street, postcode and town (a postal address you can be reached at, no P.O. box).",
    "field.platform.email.label": "Contact e-mail",
    "field.platform.email.help": "For the imprint and for data protection requests.",
    "field.platform.phone.label": "Phone",
    "field.platform.phone.help": "A second fast way to reach you (imprint).",
    "field.platform.vatId.label": "VAT ID",
    "field.platform.vatId.help": "Only if you have one (imprint).",
    "field.platform.responsible.label": "Responsible for the content",
    "field.platform.responsible.help": "Name and address of the person responsible for editorial content (only if the platform publishes such content).",
    "field.platform.registrationOpen.label": "Allow new users to register",
    "field.platform.registrationOpen.help": "Off: the sign-up page shows “limited access”; administrators add users themselves.",
    "set.group.layers.candles": "Candle structures",
    "field.layers.candles.bars.label": "Candle structures shown back",
    "field.layers.candles.bars.help": "Candle structures within this many bars are marked.",
    "field.layers.candles.max.label": "Candle structures at most",
    "field.layers.candles.max.help": "The newest candle structures marked at once.",
  } as Record<string, string>,
  de: {
    "set.navLabel": "Bereiche der Einstellungen",
    "set.nav.users": "Benutzer",
    "set.nav.domain": "Domain",
    "set.mode.title": "Betriebsmodus",
    "set.mode.hint": "Entwicklung: Änderungen sofort sichtbar. Produktion: gebaut und schnell.",
    "set.mode.dev": "Entwicklung",
    "set.mode.prod": "Produktion",
    "set.mode.confirm": "Auf {mode} umschalten? Die App startet am Ende neu (für Produktion wird zuerst gebaut, 1–2 Minuten); schlägt der Build fehl, bleibt der jetzige Modus.",
    "set.mode.running": "Wechsel auf {mode} läuft – die App startet am Ende neu, diese Seite lädt von selbst neu …",
    "set.mode.failed": "Der Wechsel auf {mode} ist fehlgeschlagen; die App läuft weiter wie zuvor.",
    "set.mode.done": "Am {date} auf {mode} umgeschaltet.",
    "set.domain.hint": "Die Adresse, unter der diese Installation erreichbar ist. Beim Domain-Anbieter einen A-Eintrag (bei IPv6 auch AAAA) des Namens auf die IP dieses Servers setzen; HTTPS kommt dann beim ersten Aufruf von selbst.",
    "set.domain.host": "Domain",
    "set.domain.placeholder": "z. B. trading.beispiel.de",
    "set.domain.apply": "Übernehmen und prüfen",
    "set.domain.checking": "Wird geprüft – das Zertifikat wird jetzt geholt, das kann bis zu einer Minute dauern …",
    "set.domain.recheck": "Erneut prüfen",
    "set.domain.remove": "Entfernen",
    "set.domain.removeConfirm": "Domain {host} entfernen? HTTPS endet für sie; die App bleibt über die IP des Servers erreichbar.",
    "set.domain.none": "Noch keine Domain: Die App ist über die IP des Servers erreichbar (ohne HTTPS).",
    "set.domain.active": "Aktiv seit {date} – https://{host}",
    "set.domain.pending": "Noch nicht geprüft",
    "set.domain.failed": "Prüfung fehlgeschlagen",
    "set.adminOnly": "Nur für Administratoren",
    "set.nav.layers": "Chart-Ebenen",
    "set.nav.preferences": "Präferenzen",
    "set.nav.data": "Marktdaten",
    "set.nav.platform": "Plattform",
    "set.messenger.row": "Telegram-Bot",
    "set.messenger.none": "Nicht eingerichtet",
    "set.messenger.posting": "{bot} → {chat}",
    "set.messenger.noChat": "{bot} · noch kein Kanal gewählt",
    "set.messenger.setUp": "Einrichten",
    "set.messenger.change": "Verwalten",
    "set.messenger.setUpTitle": "Telegram einrichten",
    "set.messenger.step.bot": "1. Der Bot",
    "set.messenger.step.chat": "2. Der Kanal oder die Gruppe",
    "set.messenger.otherBot": "Anderer Bot",
    "set.messenger.chatNow": "Postet in {chat}",
    "set.messenger.chatStep1": "Füge {bot} deinem Kanal oder deiner Gruppe als Administrator hinzu (Kanal: Administratoren → Admin hinzufügen; Gruppe: Mitglieder hinzufügen).",
    "set.messenger.chatStep2": "Dann hier suchen und auswählen – der Bot postet dort eine kurze Bestätigung.",
    "set.messenger.search": "Chats suchen",
    "set.messenger.noChats": "Noch kein Kanal und keine Gruppe gefunden. Füge {bot} hinzu und suche erneut. Fehlt sie weiter? Telegram meldet dem Bot nur die letzten 24 Stunden: Schreibe in der Gruppe /start{bot} (normale Nachrichten sieht der Bot dort nicht) oder poste etwas im Kanal, dann erneut suchen. Dein Einzelchat mit dem Bot wird nicht angeboten – die Tipps liest nur, wer einem Kanal oder einer Gruppe beitritt.",
    "set.messenger.kind.channel": "Kanal",
    "set.messenger.kind.group": "Gruppe",
    "set.messenger.choose": "Wählen",
    "set.messenger.chosen": "Gewählt",
    "set.messenger.step1": "In Telegram @BotFather öffnen und /newbot senden.",
    "set.messenger.step2": "Einen Namen und einen Benutzernamen wählen, der auf „bot“ endet (z. B. IllustradingBot).",
    "set.messenger.step3": "Den Token aus seiner Antwort kopieren und unten einfügen – die ganze Antwort geht auch.",
    "set.messenger.hint": "Postet jeden neuen Trade-Tipp in einen Telegram-Kanal oder eine Gruppe – wer die Tipps lesen soll, tritt bei.",
    "set.messenger.token": "Bot-Token",
    "set.messenger.tokenHelp": "123456789:AAH… – oder die ganze Antwort von BotFather einfügen",
    "set.messenger.save": "Prüfen und speichern",
    "set.messenger.saveHint": "Der Token wird vor dem Speichern bei Telegram geprüft und verschlüsselt abgelegt; ein vorher eingerichteter Bot wird ersetzt.",
    "set.messenger.remove": "Bot entfernen",
    "set.messenger.removeConfirm": "Den Bot {bot} entfernen? Er postet dann keine neuen Tipps mehr.",
    "set.section.layers.title": "Chart-Ebenen",
    "set.section.preferences.title": "Präferenzen",
    "set.section.preferences.description": "Sprache und Darstellung.",
    "set.section.data.title": "Marktdaten",
    "set.section.data.description": "Welcher Marktdaten-Anbieter welche Anlageklasse bedient und wie oft die Daten aktualisiert werden.",
    "set.section.platform.title": "Plattform",
    "set.section.platform.description": "Einstellungen für Administratoren.",
    "set.saved": "Gespeichert — gilt ab sofort.",
    "set.confirmReset": "Standardwerte für „{name}“ wiederherstellen?",
    "set.defaultsRestored": "Standardwerte wiederhergestellt.",
    "set.saving": "Wird gespeichert …",
    "set.autoSave": "Änderungen werden automatisch gespeichert.",
    "set.saveChanges": "Änderungen speichern",
    "set.discard": "Verwerfen",
    "set.restoreDefaults": "Standardwerte wiederherstellen",
    "set.data.otherTitle": "Nachrichten, Kalender, Aktualisierung",
    "set.data.providerTitle": "Anbieter je Anlageklasse",
    "set.account.roleAdmin": "Administrator",
    "set.account.roleUser": "Nutzer",
    "set.users.hint": "Alle, die auf dieser Plattform registriert sind. Administratoren verwalten zusätzlich Marktdaten, Plattform und Benutzer; jeder Benutzer hat eigene Watchlist und Einstellungen.",
    "set.users.name": "Benutzer",
    "set.users.vote": "Voting",
    "set.users.voteHelp": "Wer das Voting nutzen darf: Abstimmen (Trade-Tipps abgeben, über die der anderen abstimmen, Benachrichtigungen), Nur ansehen (Tipps und Stimmen sehen, Benachrichtigungen) oder Aus.",
    "set.users.voteAdmin": "Administratoren stimmen immer ab.",
    "set.users.voteOf": "Voting von {name}",
    "set.users.voteAccess.vote": "Abstimmen",
    "set.users.voteAccess.view": "Nur ansehen",
    "set.users.voteAccess.off": "Aus",
    "set.users.role": "Rolle",
    "set.users.email": "E-Mail",
    "set.users.since": "Registriert",
    "set.users.lastSeen": "Zuletzt aufgerufen",
    "set.users.you": "du",
    "set.users.add": "Benutzer hinzufügen",
    "set.users.password": "Passwort (mind. 10 Zeichen)",
    "set.users.added": "{name} hinzugefügt — die Anmeldung erfolgt mit dieser E-Mail-Adresse und diesem Passwort.",
    "set.users.roleOf": "Rolle von {name}",
    "set.users.delete": "{name} löschen",
    "set.users.deleteConfirm": "{name} ({email}) endgültig löschen — mit Tipps, Stimmen, Watchlist, Einstellungen und Zeichnungen?",

    "field.suffix.atr": "× ATR",
    "field.suffix.minutes": "Minuten",
    "field.suffix.bars": "Kerzen",
    // Chart-Ebenen — eine Gruppe je Ebene des Ebenen-Menüs
    "set.group.layers.events": "Struktur (Sweep / BOS)",
    "set.group.layers.levels": "Unterstützung / Widerstand / Liquidität",
    "set.group.layers.fvg": "Fair Value Gaps",
    "set.group.layers.orderBlocks": "Order Blocks",
    "set.group.layers.breakers": "Breaker Blocks",
    "set.group.layers.poi": "POI (Point of Interest)",
    "set.group.layers.supplyDemand": "Angebot / Nachfrage (Seiden)",
    "set.group.layers.srZones": "Unterstützungs- / Widerstandszonen",
    "set.group.layers.dayLevels": "Tages-Levels (New York)",
    "set.layers.note": "Wie die Ebenen des Charts gezeichnet werden: wie weit zurück und wie viele Struktur-Ereignisse, Levels, Liquidität, Fair Value Gaps, Order und Breaker Blocks, Points of Interest, Angebots-/Nachfrage- und Unterstützungs-/Widerstandszonen und Candle-Strukturen gezeigt werden, und die runden Zahlen. Nur Darstellung: Prüfungen und Modell messen dieselben Bausteine unabhängig davon.",
    "field.layers.events.bars.label": "Ereignisse zurück",
    "field.layers.events.bars.help": "Strukturbrüche und Sweeps innerhalb so vieler Kerzen werden gezeichnet.",
    "field.layers.events.max.label": "Ereignisse höchstens",
    "field.layers.events.max.help": "Die jüngsten Ereignisse, die zugleich gezeichnet werden.",
    "field.layers.levels.lookback.label": "Swing-Levels blicken zurück",
    "field.layers.levels.lookback.help": "Swing-Hochs über und -Tiefs unter dem Kurs innerhalb so vieler Kerzen zählen als Widerstand / Unterstützung.",
    "field.layers.levels.perSide.label": "Levels je Seite",
    "field.layers.levels.perSide.help": "Wie viele der jüngsten Swing-Hochs über und Swing-Tiefs unter dem Kurs als Widerstand / Unterstützung gezeichnet werden.",
    "field.layers.levels.liquidityBars.label": "Liquidität blickt zurück",
    "field.layers.levels.liquidityBars.help": "Gleiche Hochs / Tiefs innerhalb so vieler Kerzen, die nie durchschlossen wurden, bilden einen Liquiditätspool.",
    "field.layers.levels.liquidityTolAtr.label": "Gleiche Hochs / Tiefs innerhalb",
    "field.layers.levels.liquidityTolAtr.help": "Swings höchstens so viele ATR auseinander gelten als gleich (ein Pool).",
    "field.layers.levels.liquidityMax.label": "Liquiditätspools höchstens",
    "field.layers.levels.liquidityMax.help": "Die dem Kurs nächsten Pools, die gezeichnet werden (0 = keine).",
    "field.layers.fvg.lookback.label": "Offene Lücken zurück",
    "field.layers.fvg.lookback.help": "Eine offene Lücke innerhalb so vieler Kerzen wird gezeichnet.",
    "field.layers.fvg.max.label": "Lücken höchstens",
    "field.layers.fvg.max.help": "Die jüngsten offenen Lücken, die zugleich gezeichnet werden.",
    "field.layers.orderBlocks.max.label": "Order Blocks höchstens",
    "field.layers.orderBlocks.max.help": "Die jüngsten noch stehenden Order Blocks, die zugleich gezeichnet werden (LuxAlgo: 5).",
    "field.layers.breakers.max.label": "Breaker Blocks höchstens",
    "field.layers.breakers.max.help": "Die jüngsten noch stehenden Breaker Blocks, die zugleich gezeichnet werden.",
    "field.layers.poi.max.label": "POIs höchstens",
    "field.layers.poi.max.help": "Die jüngsten Points of Interest – offene, unberührte Order Blocks und Gaps, die ein Strukturbruch hinterlassen hat –, die zugleich gezeichnet werden.",
    "field.layers.supplyDemand.lookback.label": "Zonen zurück",
    "field.layers.supplyDemand.lookback.help": "Eine Zone, deren Basis innerhalb so vieler Kerzen liegt, wird gezeichnet.",
    "field.layers.supplyDemand.max.label": "Zonen höchstens",
    "field.layers.supplyDemand.max.help": "Die jüngsten noch stehenden Zonen, die zugleich gezeichnet werden.",
    "field.layers.srZones.lookback.label": "Swings zurück",
    "field.layers.srZones.lookback.help": "Die Swing-Hochs und -Tiefs innerhalb so vieler Kerzen werden zu Zonen gebündelt.",
    "field.layers.srZones.widthAtr.label": "Zonenbreite",
    "field.layers.srZones.widthAtr.help": "So nah beieinander liegende Swings bilden eine Zone (1 ATR: ein Swing ± eine halbe ATR).",
    "field.layers.srZones.max.label": "Zonen höchstens",
    "field.layers.srZones.max.help": "Die stärksten Zonen (meiste Swings), die sich nicht überlappen.",
    "field.layers.dayLevels.roundStep.label": "Runde Zahlen alle",
    "field.layers.dayLevels.roundStep.help": "Die runden Kursmarken neben dem Kurs, die als Tages-Levels gezeichnet werden (0 = keine).",
    "set.table.setting": "Einstellung",
    "set.table.description": "Beschreibung",
    "set.table.value": "Wert",
    "set.table.default": "Standard",
    "set.choice.none": "keine",
    "set.table.applyDefault": "Standardwert übernehmen",
    "set.value.on": "Ein",
    "set.value.off": "Aus",
    "field.preferences.language.label": "Sprache",
    "field.preferences.language.help": "Sprache der Oberfläche.",
    "field.preferences.language.de": "Deutsch",
    "field.preferences.language.en": "English",
    "field.preferences.theme.label": "Erscheinungsbild",
    "field.preferences.setupTimeframe.label": "Standard-Zeitebene",
    "field.preferences.setupTimeframe.help": "Ein Markt öffnet auf dieser Zeitebene (im Chart umstellbar); die Veränderung in der Watchlist wird darauf gemessen.",
    "field.preferences.timeZone.label": "Zeitzone",
    "field.preferences.timeZone.help": "Alle Zeiten der App erscheinen darin: Achse und Fadenkreuz des Charts, Kalender, News und Tipps (auch an der Uhr unten am Chart wählbar).",
    "field.preferences.theme.system": "Wie System",
    "field.preferences.theme.blue": "Blau",
    "field.preferences.theme.green": "Grün",
    "field.preferences.theme.red": "Rot",
    "field.preferences.theme.white": "Weiß",
    "field.data.refreshMinutesDaily.label": "Tagesdaten aktualisieren alle",
    "field.data.refreshMinutesIntraday.label": "Intraday-Daten aktualisieren alle",
    "field.platform.operator.label": "Anbieter",
    "field.platform.operator.help": "Name der Person oder Firma, die die Plattform betreibt — steht im Impressum, in den AGB und in der Datenschutzerklärung.",
    "field.platform.address.label": "Anschrift",
    "field.platform.address.help": "Straße, Postleitzahl und Ort (eine ladungsfähige Anschrift, kein Postfach).",
    "field.platform.email.label": "Kontakt-E-Mail",
    "field.platform.email.help": "Für das Impressum und für Anfragen zum Datenschutz.",
    "field.platform.phone.label": "Telefon",
    "field.platform.phone.help": "Ein zweiter schneller Kontaktweg (Impressum).",
    "field.platform.vatId.label": "USt-IdNr.",
    "field.platform.vatId.help": "Nur falls vorhanden (Impressum).",
    "field.platform.responsible.label": "Inhaltlich verantwortlich",
    "field.platform.responsible.help": "Name und Anschrift der Person, die für redaktionelle Inhalte verantwortlich ist (nur falls die Plattform solche veröffentlicht).",
    "field.platform.registrationOpen.label": "Registrierung neuer Nutzer erlauben",
    "field.platform.registrationOpen.help": "Aus: Die Registrierung zeigt „Zugang derzeit limitiert“; Admins legen Nutzer selbst an.",
    "set.group.layers.candles": "Candle-Strukturen",
    "field.layers.candles.bars.label": "Candle-Strukturen zurück",
    "field.layers.candles.bars.help": "Candle-Strukturen innerhalb so vieler Kerzen werden markiert.",
    "field.layers.candles.max.label": "Candle-Strukturen höchstens",
    "field.layers.candles.max.help": "Die neuesten Candle-Strukturen, die gleichzeitig markiert werden.",
  } as Record<string, string>,
};
